module.exports = __webpack_public_path__ + "static/media/featureQuality_hero.459fc5f1.jpg";